<template>
  <CSidebar
      fixed
      :minimize="minimize"
      :show="show"
 class="bg-dark-gradient"
      dropdownMode="closeInactive"
      @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none c-sidebar-brand-full">
      <CRow style="width: 100%">
        <CHeaderNav>

<!--          <CImg v-show="true" class="rounded-circle" style="text-align: start;margin-right: 3px;margin-left: 3px" id="logo_image" :src="user_image" width="auto" height="50px"/>-->

<!--                    <label id="company_name"  style="text-align: start;margin-right: 3px;margin-left: 3px">فروشگاه</label>-->
<!--                    <label  @click="go_to_site()" style="cursor: pointer"><CIcon name="eye"/></label>-->

        </CHeaderNav>

      </CRow>
    </CSidebarBrand>

    <div class="user-name-section" v-if="user_name">
<!--      <CImg v-show="true" class="rounded-circle" style="text-align: start;margin-right: 3px;margin-left: 3px" id="logo_image" :src="user_image" width="auto" height="50px"/>-->

      <div class="user-name-text">{{ user_name }}</div>
      <div class="subscription-section">
        <div class="subscription-text">
          {{ $t('expire_subscription') }}
          {{ remaining_days }}
          {{ $t('days') }}</div>
      </div>
    </div>

    <CRenderFunction ref="sidebar_ref" flat :content-to-render="generate_nav"/>
    <!--    <CRenderFunction flat :content-to-render="$options.nav"/>-->
    <div class="logout-button" v-on:click="go_login()">
      <svg class="logout-icon" fill="currentColor" width="16px" height="16px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M25,2H16V4h9a1,1,0,0,1,1,1V27a1,1,0,0,1-1,1H16v2h9a3,3,0,0,0,3-3V5A3,3,0,0,0,25,2Z"/>
        <path d="M21.58,17V15H7l4-4L9.58,9.55l-5,5a2,2,0,0,0,0,2.83l5,5L11,21,7,17Z"/>
      </svg>
      <span style="text-align: start">{{ $t('logout') }}</span>
    </div>
  </CSidebar>
</template> 

<script>
import nav from './_nav'
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import router from "@/router" ; 
import axios from 'axios';
export default {
  name: 'TheSidebar',
  nav,
  components: {
    TheHeaderDropdownAccnt
  },
  data() {
    return {
      branch_name: localStorage.getItem("branchName"),
      sidebar_changer: null,
      side_bar_drop_downs: null,
      opened_drop_downs: '',
      user_name: '',
      user_image: '',
      unread_message_count:0,
      remaining_days: 340, // این مقدار بعداً از API دریافت خواهد شد
    }
  },
  computed: {

    show() {
      return this.$store.state.sidebarShow
    },
    minimize() {
      return this.$store.state.sidebarMinimize
    },
    go_to_site() {
window.open(localStorage.getItem("site_url"))
    },
    generate_nav() {
      var out_pot = nav;
      let permissions = localStorage.getItem("permissions");
      // console.log("sidebar generate nav called "+permissions);
      // console.log("sidebar generate nav called "+JSON.stringify(out_pot[0]._children));
      for(var oo =out_pot[0]._children.length - 1;oo>=0;oo--) {
        var val = out_pot[0]._children[oo]
        var val_index = oo;
        // }
        // out_pot[0]._children.forEach((val, val_index) => {

        if (val.items != null) {
          for (var xz = val.items.length - 1; xz >= 0; xz--) {
            var val_item = val.items[xz];
            if (val_item.role != null && !permissions.includes(val_item.role)) {
              // val_item.role = 'salam'+index;

              val.items.splice(xz, 1);

            } else if (val_item.role_access != null && !this.get_access(val_item.role_access)) {
              val.items.splice(xz, 1);

            }
          }
        }
        if (val.role_access != null && !this.get_access(val.role_access)) {
          out_pot[0]._children.splice(val_index, 1);
        }
        if (val.role != null && !permissions.includes(val.role)) {
          out_pot[0]._children.splice(val_index, 1);
        }
        // self.value_category.push(val.cat_id);
        // });
      }
      // console.log("sidebar generate nav called "+JSON.stringify(out_pot[0]._children));


      return out_pot;
      // console.log(JSON.stringify(nav));

    },

  },
  mounted() {
    this.get_user_name();
    var self = this;
    this.side_bar_drop_downs = this.$refs['sidebar_ref'].$children[0].$children[0].$children
    this.sidebar_changer = this.$refs['sidebar_ref'].$el;
    console.log("localStorage.getItem('market_expire')",localStorage.getItem('market_expire'))
    this.remaining_days =  (new Date(localStorage.getItem('market_expire')) - new Date()) / (1000*24*60*60)
    this.remaining_days = parseInt( this.remaining_days)
    this.user_image =  localStorage.getItem('image');

    this.style_logout_button();
    var CLASS_NAME_ACTIVE = 'c-active';

    var SELECTOR_NAV_LINK = '.c-xhr-link, .c-sidebar-nav-link';
    var SELECTOR_NAV_ITEM = '.c-sidebar-nav-item';
this.$router.afterEach((to, from) => {
  console.log("after each called",to.path)
  setTimeout(() => {

    var url = to.path

    Array.from(document.querySelectorAll(SELECTOR_NAV_LINK)).forEach(element => {
      element.classList.remove(CLASS_NAME_ACTIVE)
    })

    Array.from(document.querySelectorAll(SELECTOR_NAV_LINK)).forEach(element => {
      element.classList.remove(CLASS_NAME_ACTIVE)
    })


    Array.from(document.querySelectorAll(`${SELECTOR_NAV_ITEM} a[href="${url}"]`)).forEach(element => {
      element.classList.add(CLASS_NAME_ACTIVE)
    })

  }, 500);

})

    for (var i = 0; i < this.side_bar_drop_downs.length; i++) {

      var self = this;
      this.side_bar_drop_downs[i].$el.getElementsByTagName('a')[0].addEventListener('click', function (e) {

        console.log("changed side bar", this.parentElement.parentElement)
// var this_el ='';
        for (var z = 0; z < self.side_bar_drop_downs.length; z++) {
          if (self.side_bar_drop_downs[z].$el.classList.contains("c-show")) {
            self.side_bar_drop_downs[z].$el.classList.remove("c-show");
            // this_el =self.side_bar_drop_downs[z].$el;
          }
        }
        // if(this_el != this){
        if (self.opened_drop_downs != this.parentElement) {
          self.opened_drop_downs = this.parentElement;
          console.log("clicked sidebar", this.parentElement)

          this.parentElement.classList.add("c-show");
          var sidenav = this.parentElement.parentElement;
          try {
            const lastChild = this.parentElement.getElementsByTagName('ul')[0].getElementsByTagName('li')[this.parentElement.getElementsByTagName('ul')[0].getElementsByTagName('li').length - 1];
            console.log("last child is ", lastChild)
            const lastChildRect = lastChild.getBoundingClientRect();
            const lastChildBottom = lastChildRect.bottom;

            const sidenavHeight = sidenav.getBoundingClientRect().bottom;

            if (lastChildBottom > sidenavHeight) {
              console.log('Scroll', sidenavHeight, lastChildBottom);
              // lastChild.scrollIntoView();


              setTimeout(function () {
                sidenav.scroll({
                  top: lastChildBottom - sidenavHeight + 100,
                  behavior: 'smooth'
                });
              }, 150);
            }
          } catch (e) {

          }

        } else {
          self.opened_drop_downs = "";
          console.log("all closed");
          var sidenav2 = this.parentElement.parentElement;
          sidenav2.scroll({
            top: -500,
            behavior: 'smooth'
          });
        }

        // }

      })


    }
  },
  methods: {
    get_user_name() {
      this.user_name = localStorage.getItem("user_name") || '';
    },
    go_login(){

      localStorage.setItem('token','');
      this.$router.push({ path: '/dashboard/login'});
    },
    scroll_sidebar() {

    },
    style_logout_button() {
      this.$nextTick(() => {
        setTimeout(() => {
          const logoutLinks = document.querySelectorAll('a[href="#logout"]');
          logoutLinks.forEach(link => {
            const navItem = link.closest('.c-sidebar-nav-item');
            if (navItem) {
              navItem.style.backgroundColor = '#dc3545';
              navItem.style.color = '#fff';
              const linkElement = navItem.querySelector('a');
              if (linkElement) {
                linkElement.style.color = '#fff';
              }
              // Remove existing handler if exists
              if (link.dataset.logoutHandler) {
                return;
              }
              link.dataset.logoutHandler = 'true';
              link.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                this.go_login();
              }, true); // Use capture phase like Vue's v-on:click
            }
          });
        }, 500);
      });
    }
  },
  watch: {
    'sidebar_changer': function () {
      console.log("side bar changed")
      this.style_logout_button();
    }
  }
}
</script>

<style scoped>
.user-name-section {
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: #ffffff;
  margin: 10px;
  border-radius: 5px;
}

.user-name-text {
  color: #000;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}

.subscription-section {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.subscription-text {
  color: #000;
  font-size: 12px;
  text-align: center;
  font-weight: 500;
}

/* Style for logout button */
::v-deep .c-sidebar-nav-item a[href="#logout"] {
  color: #fff !important;
}

::v-deep .c-sidebar-nav-item:has(a[href="#logout"]) {
  background-color: #dc3545 !important;
  margin-top: 10px;
}

::v-deep .c-sidebar-nav-item:has(a[href="#logout"]):hover {
  background-color: #c82333 !important;
}

::v-deep .c-sidebar-nav-item:has(a[href="#logout"]) .c-sidebar-nav-icon {
  color: #fff !important;
}

.logout-button {
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 0.75rem 1rem;
  margin: 5px 10px;
  background-color: transparent;
  color: #6e82a5;
  cursor: pointer;
  border-radius: 9px;
  transition: all 0.2s;
  border: none;
  width: calc(100% - 20px);
}

.logout-button:hover {
  color: #8351ec;
  background-color: #F5F0FF;
}

.logout-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  fill: currentColor;
}

.logout-button span {
  flex: 1;
  text-align: right;
}

/* Override h-100 for c-sidebar-nav to fit content */
::v-deep ul.c-sidebar-nav.h-100.ps.ps__rtl,
::v-deep .c-sidebar-nav.h-100,
::v-deep .c-sidebar-nav.h-100.ps,
::v-deep .c-sidebar-nav.h-100.ps__rtl,
::v-deep .c-sidebar-nav.ps.ps__rtl {
  height: auto !important;
  min-height: auto !important;
  max-height: none !important;
  flex: 0 0 auto !important;
}
</style>
